import { CameraAltOutlined } from "@mui/icons-material";
import type { ReactNode } from "react";
import PiWidget from "../../components/pi_widget/PiWidget";
import PiWidgetToggleButton from "../../components/pi_widget/PiWidgetToggleButton";
import { useSelector } from "react-redux";
import {
  SelectedTab,
  selectSelectedTab,
  selectShowCameraWidget,
  setShowCameraWidget,
} from "../../app/slices/GlobalSlice";
import { useDispatch } from "react-redux";

export default function ViewportTools(props: { children?: ReactNode }) {
  const { children } = { ...props };
  const checked = useSelector(selectShowCameraWidget);
  const dispatch = useDispatch();
  const timelineSelected =
    useSelector(selectSelectedTab) === SelectedTab.Timeline;

  const widget = (
    <PiWidget>
      <>
        <PiWidgetToggleButton
          checked={checked}
          icon={<CameraAltOutlined />}
          onClick={() => dispatch(setShowCameraWidget(!checked))}
        />
        {children}
      </>
    </PiWidget>
  );

  return <>{timelineSelected && widget}</>;
}
